import { Pipe } from '@angular/core';

import type { PipeTransform } from '@angular/core';

export type DatePipeOptions = {
  emptyIfError?: boolean;
  infinityChar?: string;
  withTime?: true;
};

@Pipe({ name: 'kpDate' })
export class DatePipe implements PipeTransform {
  transform(value?: string | Date, removeYear = false): string {
    const options: Intl.DateTimeFormatOptions = {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
    };

    // oxlint-disable-next-line new-cap
    const date = Intl.DateTimeFormat('cs-CZ', options).format(
      value ? new Date(value) : undefined,
    );

    return removeYear ? date.split(' ').slice(0, 2).join(' ') : date;
  }
}
